import { render, staticRenderFns } from "./CampaignPageHeader.vue?vue&type=template&id=7681111a&scoped=true&"
import script from "./CampaignPageHeader.vue?vue&type=script&lang=js&"
export * from "./CampaignPageHeader.vue?vue&type=script&lang=js&"
import style0 from "./CampaignPageHeader.vue?vue&type=style&index=0&id=7681111a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7681111a",
  null
  
)

export default component.exports